// src/pages/PoliticaCookies.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaFileContract, FaShieldAlt, FaCookieBite, FaStore } from 'react-icons/fa';
import '../styles/LegalPages.css';

const PoliticaCookies = () => {
  return (
    <div className="legal-page">
      <div className="legal-energy-field">
        <div className="legal-energy-bolt"></div>
        <div className="legal-energy-bolt"></div>
        <div className="legal-energy-bolt"></div>
      </div>

      <div className="legal-container">
        <header className="legal-header">
          <h1>🍪 Política de Cookies</h1>
          <p className="legal-subtitle">
            Información sobre el uso de cookies en Reanimeitor
          </p>
        </header>

        <div className="legal-content">
          <div className="legal-section">
            <p>
              Esta Política de Cookies explica qué son las cookies, cómo las utilizamos 
              en el sitio web <strong>Reanimeitor</strong> y cómo puedes gestionarlas.
            </p>
          </div>

          <div className="legal-section">
            <h2>❓ ¿Qué son las cookies?</h2>
            <p>
              Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo 
              cuando visitas un sitio web. Sirven para recordar información sobre tu visita, 
              como idioma, preferencias o datos de acceso.
            </p>
          </div>

          <div className="legal-section">
            <h2>📊 ¿Qué tipos de cookies usamos?</h2>
            <ul className="legal-list">
              <li>
                <strong>🍪 Cookies técnicas:</strong> necesarias para el funcionamiento 
                básico del sitio. Permiten la navegación y el uso de funcionalidades esenciales.
              </li>
              <li>
                <strong>🎨 Cookies de personalización:</strong> permiten recordar tus 
                preferencias, como el tema claro u oscuro.
              </li>
              <li>
                <strong>🚫 No usamos cookies de terceros ni de análisis</strong> en este momento.
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>⚙️ Gestión de cookies</h2>
            <p>
              Puedes configurar tu navegador para aceptar o rechazar cookies, o para que 
              te avise antes de que se almacenen. Ten en cuenta que desactivar las cookies 
              técnicas puede afectar al funcionamiento del sitio.
            </p>
          </div>

          <div className="legal-section">
            <h2>✅ Consentimiento</h2>
            <p>
              Al continuar navegando en este sitio, aceptas el uso de las cookies descritas. 
              Puedes modificar tu consentimiento en cualquier momento desde la configuración 
              de tu navegador.
            </p>
          </div>

          <div className="legal-section">
            <h2>📞 Contacto</h2>
            <p>
              Si tienes dudas sobre esta política, puedes escribirnos a 
              <strong> reanimeitor.energy@gmail.com</strong>.
            </p>
          </div>

          <Link to="/" className="legal-back-button">
            <FaArrowLeft /> Volver al Inicio
          </Link>

          <div className="legal-navigation">
            <Link to="/aviso-legal" className="legal-nav-button">
              <FaFileContract /> Aviso Legal
            </Link>
            <Link to="/politica-privacidad" className="legal-nav-button">
              <FaShieldAlt /> Privacidad
            </Link>
            <Link to="/politica-tienda" className="legal-nav-button">
              <FaStore /> Tienda
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaCookies;